import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './story.routes';
import showHtml from './model/show.html';
import showCommentsHtml from './model/showComments.html';
import addCommentHtml from './model/addComment.html';

export class StoryController {
    $http;
    socket;
    awesomeStories = [];
    internal_type;

    /*@ngInject*/
    constructor($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location, $timeout, $rootScope) {
        this.$http = $http;
        this.socket = socket;
        this.$uibModal = $uibModal;
        this.$cookies = $cookies;
        this.$cookieStore = $cookieStore;
        this.$location = $location;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;

        this.internal_type = {
            1: '新',
            2: '差',
            3: '好',
            4: '精选'
        };

        this.internal_type_selector = [
            {value: 1, name: '新'},
            {value: 2, name: '差'},
            {value: 3, name: '好'},
            {value: 4, name: '精选'}
        ];

        this.language_type = {
            en: '英语',
            pt: '葡语',
            es: '西语'
        };
        this.language_type_selector = [
            {value: 'en', name: '英语'},
            {value: 'pt', name: '葡语'},
            {value: 'es', name: '西语'},
        ];

        this.cold_datas = [
            {value: '1', name: '用户发布'},
            {value: '0', name: '运营发布'},
        ];
    }

    $onInit() {
        if(this.$cookies.get('token')) {
            this.$http.get('/api/stranger_community_storys/', {
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    token: this.$cookies.get('token')
                },
                params: {
                    page: 0,
                    size: 20,
                    type: 'admin'
                }
            })
                .then(response => {
                    if(response.data.data) {
                        this.maxSize = 20;
                        this.totalCount = response.data.data.count;
                        this.totalItems = response.data.data.count / 2;
                        this.currentPage = 1;

                        response.data.data.rows.forEach(story => {
                            story.internal_type = this.internal_type[story.internal_type];
                        });


                        this.awesomeStories = response.data.data.rows;
                        // this.socket.syncUpdates('story', this.awesomeStorys);
                    }
                });
        } else {
            this.$location.path('main');
        }
    }

    showContent(content, title) {
        this.$uibModal.open({
            template: showHtml,
            size: 'lg',
            /*@ngInject*/
            controller($scope, $http, $uibModalInstance) {
                $scope.content = content;
                $scope.title = title;
                $scope.cancel = function() {
                    $uibModalInstance.close();
                };
            }
        });
    }

    showComments(story) {
        const that = this;

        return this.$http.get('/api/stranger_story_comments/', {
            header: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                token: this.$cookies.get('token')
            },
            params: {
                page: 0,
                size: 1000,
                story_id: story._id
            }
        })
            .then(response => {
                if(response.data.data) {
                    this.$uibModal.open({
                        template: showCommentsHtml,
                        size: 'lg',
                        /*@ngInject*/
                        controller($scope, $http, $uibModalInstance) {
                            $scope.awesomeComments = response.data.data.rows;
                            $scope.title = story.title;
                            $scope.cancel = function() {
                                $uibModalInstance.close();
                            };
                            $scope.deleteComment = function(entity) {
                                that.$http.delete(`/api/stranger_story_comments/${entity._id}`).then(res => {
                                    if(res.status === 204) {
                                        $uibModalInstance.close();
                                        that.showComments(story).then(function() {
                                            that.search();
                                        });
                                    }
                                });
                            };
                        }
                    });
                }
            });
    }

    markEditorPicked(story) {
        this.$http.put(`/api/stranger_community_storys/${story._id}`, {
            internal_type: 4,
            user_id: story.user_id,
            story_id: story._id
        }, {
            header: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                token: this.$cookies.get('token')
            }
        }).then(res => {
            if(res.data.data) {
                console.log(res);
                this.search();
            }
        });
    }

    unMarkEditorPicked(story) {
        this.$http.put(`/api/stranger_community_storys/${story._id}`, {internal_type: 3}, {
            header: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                token: this.$cookies.get('token')
            }
        }).then(res => {
            if(res.data.data) {
                this.search();
            }
        });
    }

    unMarkExposure(story) {
        this.$http.put(`/api/stranger_community_storys/${story._id}`, {doesExposure: false}, {
            header: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                token: this.$cookies.get('token')
            }
        }).then(res => {
            if(res.data.data) {
                this.search();
            }
        });
    }

    markExposure(story) {
        this.$http.put(`/api/stranger_community_storys/${story._id}`, {doesExposure: true}, {
            header: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                token: this.$cookies.get('token')
            }
        }).then(res => {
            if(res.data.data) {
                this.search();
            }
        });
    }

    addStoryComment(story) {
        const that = this;
        this.$uibModal.open({
            template: addCommentHtml,
            size: 'lg',
            /*@ngInject*/
            controller: function($scope, $http, $uibModalInstance) {
                $scope.vm = {
                    story_id: story._id,
                    user_id: 0,
                };
                $scope.save = function(myForm) {
                    if(myForm.$valid === false) {
                        return false;
                    } else {
                        $http.post('/api/stranger_story_comments', $scope.vm).then(response => {
                            $uibModalInstance.close(response.data.data);
                            that.showComments(story); // todo refresh asynchronous data
                        }, error => {
                            console.log(error);
                        });
                    }
                };
                $scope.cancel = function() {
                    $uibModalInstance.close();
                };
            }
        });
    }

    /**
     *
     * @param val 第一页查起
     */
    search(val) {
        if(val === true) {
            this.currentPage = 1;
        }
        const payload = angular.copy(this.filters || {});

        if(payload.hasOwnProperty('_id')) {
            payload._id = parseInt(payload._id, 10);
        }
        if(payload.hasOwnProperty('user_id')) {
            payload.user_id = parseInt(payload.user_id, 10);
        }
        if(payload.hasOwnProperty('internal_type')) {
            payload.internal_type = parseInt(payload.internal_type, 10);
        }

        if(payload.hasOwnProperty('exposure_start')) {
            payload.exposure_start = parseInt(payload.exposure_start, 10);
        }
        if(payload.hasOwnProperty('exposure_end')) {
            payload.exposure_end = parseInt(payload.exposure_end, 10);
        }

        if(payload.hasOwnProperty('commented_start')) {
            payload.commented_start = parseInt(payload.commented_start, 10);
        }
        if(payload.hasOwnProperty('commented_end')) {
            payload.commented_end = parseInt(payload.commented_end, 10);
        }

        if(payload.hasOwnProperty('does_cold_data')) {
            payload.does_cold_data = parseInt(payload.does_cold_data, 10);
        }
        const ret = {
            filters: payload || {},
            page: this.currentPage - 1,
            size: 20,
            type: 'admin'
        };
        if(this.$cookies.get('token')) {
            this.$http.get('/api/stranger_community_storys/', {
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    token: this.$cookies.get('token')
                },
                params: ret
            })
                .then(response => {
                    if(response.data.data) {
                        this.maxSize = 20;
                        this.totalCount = response.data.data.count;
                        this.totalItems = response.data.data.count / 2;

                        response.data.data.rows.forEach(story => {
                            story.internal_type = this.internal_type[story.internal_type];
                        });
                        this.awesomeStories = response.data.data.rows;
                    }
                });
        } else {
            this.$location.path('main');
        }
    }
}

export default angular.module('tttApp.story', [uiRouter])
    .config(routing)
    .component('story', {
        template: require('./story.html'),
        controller: StoryController
    })
    .name;



// WEBPACK FOOTER //
// ./client/app/story/story.component.js